module.exports = __webpack_public_path__ + "./IvyPhoto_178dcaf08b343130083e7647f15674c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2019/IvyPhoto.png
// module id = 481
// module chunks = 0